declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[]
  }
}

export type LandingType = 'mini_game' | 'registration' | 'video'
export type GameCategory = 'wheel' | 'cards' | 'safe' | 'twist'
export type LabelClick = 'header' | 'pop-up' | 'phone' | 'email' | 'password' | (string & {})

export interface TrackEventParams {
  event: string
  category?: string
  action: string
  landing_type?: LandingType
  game_category?: GameCategory
  game_id?: string
  attempt?: number
  label?: LabelClick
  [key: string]: unknown
}

export const trackEvent = (params: TrackEventParams) => {
  if (typeof window === 'undefined') return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(params)
}
